var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"tenant-bookings-link",attrs:{"text":"","small":"","color":"primary","data-test":"tenant-bookings-link"},on:{"click":_vm.open}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("mdi-calendar-search")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }